/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
import { isProd } from '@/config'

export const logger = (...props: any) => {
  if (isProd) {
    return
  }
  console.log(...props)
}

export const infor = (...props: any) => {
  if (isProd) {
    return
  }
  console.info(...props)
}

export const errorer = (...props: any) => {
  if (isProd) {
    return
  }
  console.error(...props)
}
